const CONSTANTS = {
    PORTABILITY_DISCOUNT: 50,
    CATEGORY_IZZI_NEGOCIOS: 'izzinegocios',
    CATEGORY_IZZI_NEGOCIOS3P: 'izzinegocios_3P',
    CATEGORY_IZZI_NEGOCIOS3PM: 'izzinegocios_3PM',
    CATEGORY_IZZI_NEGOCIOS4P: 'izzinegocios_4P',
    CATEGORY_4PLAY: '4play_movil',
    CATEGORY_TRIPLEPLAY: 'tripleplay',
    CATEGORY_TRIPLEPLAY_MOVIL: 'tripleplay_movil',
    CATEGORY_RESIDENCIAL: 'residencial',
    CATEGORY_MOVIL: 'movil',
    CATEGORY_TV: 'tv',
    CATEGORY_SKY: 'offnet_sky',
};

const PLANS = {
    PLAN_4PLAY: '4p',
    PLAN_3PLAY: '3p',
    PLAN_3PLAY_MOVIL: '3pm',
    PLAN_2PLAY: '2p',
    PLAN_TV: 'tv',
    PLAN_MOVIL: 'movil',
    PLAN_TV_OFFNET: 'tv_izzi_offnet',
    PLAN_MOVIL_OFFNET: 'movil_offnet',
};

const MULTI_CATEGORIES = new Set([
    CONSTANTS.CATEGORY_4PLAY,
    CONSTANTS.CATEGORY_TRIPLEPLAY,
    CONSTANTS.CATEGORY_TRIPLEPLAY_MOVIL,
    CONSTANTS.CATEGORY_RESIDENCIAL,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS4P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3PM,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS,
]);

const MOVIL_CATEGORIES = new Set([
    CONSTANTS.CATEGORY_4PLAY,
    CONSTANTS.CATEGORY_TRIPLEPLAY_MOVIL,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS4P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3PM,
    CONSTANTS.CATEGORY_MOVIL,
]);

const NEGOCIOS_CATEGORIES = new Set([
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3PM,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS4P,
]);

const NETFLIX_CATEGORIES = new Set([
    CONSTANTS.CATEGORY_TRIPLEPLAY,
    CONSTANTS.CATEGORY_RESIDENCIAL,
]);

const LALIGA_CATEGORIES = new Set([
    CONSTANTS.CATEGORY_4PLAY,
    CONSTANTS.CATEGORY_TRIPLEPLAY,
    CONSTANTS.CATEGORY_TV,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS4P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3P,
]);

const IS_SKEELO_INCLUDED = new Set([
    CONSTANTS.CATEGORY_4PLAY,
    CONSTANTS.CATEGORY_TRIPLEPLAY,
    CONSTANTS.CATEGORY_TRIPLEPLAY_MOVIL,
    CONSTANTS.CATEGORY_RESIDENCIAL,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS4P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3PM,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS,
]);

const APPLE_TV_INCLUDED = new Set([
    CONSTANTS.CATEGORY_4PLAY,
    CONSTANTS.CATEGORY_TRIPLEPLAY,
    CONSTANTS.CATEGORY_TRIPLEPLAY_MOVIL,
    CONSTANTS.CATEGORY_RESIDENCIAL,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS4P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3PM,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS,
]);

const CLIP_PLUS_INCLUDED = new Set([
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS4P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3P,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3PM,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS,
]);

const TRIPLEPLAY_CATEGORIES = new Set([
    CONSTANTS.CATEGORY_TRIPLEPLAY,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS3P,
]);

const RESIDENCIAL_CATEGORIES = new Set([
    CONSTANTS.CATEGORY_RESIDENCIAL,
    CONSTANTS.CATEGORY_IZZI_NEGOCIOS,
]);

const TV_CATEGORIES = new Set([CONSTANTS.CATEGORY_TV]);
const CURRENT_STOCK_UNSELECTED = 'no_selected';
export {
    CONSTANTS,
    MULTI_CATEGORIES,
    MOVIL_CATEGORIES,
    CURRENT_STOCK_UNSELECTED,
    NEGOCIOS_CATEGORIES,
    NETFLIX_CATEGORIES,
    LALIGA_CATEGORIES,
    IS_SKEELO_INCLUDED,
    APPLE_TV_INCLUDED,
    CLIP_PLUS_INCLUDED,
    TRIPLEPLAY_CATEGORIES,
    RESIDENCIAL_CATEGORIES,
    TV_CATEGORIES,
};
